export const GAME_CODE = "code"
export const USER_NAME = "username"
export const FULL_NAME = "fullname"
export const CONNECTION_ID = "connection_id"
export const CLASS_ID = "c"
export const GRAPHICAL_LOGIN = "g"
export const CAN_CREATE_NEW_USERS = "ccnu"
export const SHUFFLE_ANSWERS = "sa"
export const SHUFFLE_SCREENS = "ssc"

export const DISABLE_MEMES = "dm"
export const ENABLE_TIMER = "t"
export const FORCE_NEW_GAME = "new"

export const DEBUG_SUPPRESS_CONSOLE = "suppressConsole"
